// extracted by mini-css-extract-plugin
export default {"newPasswordWrapper":"NewPassword_newPasswordWrapper--aOz","submitButton":"NewPassword_submitButton--DvZ","errorWrap":"NewPassword_errorWrap--p4Y","error":"NewPassword_error--DQ4"};